<template>
  <default-dialog ref="dialog" @hide="onDialogHide">
    <div class="image-headline">
      <lottie-player
        :src="JSON.stringify(require('@/assets/animations/meh-smiley.json'))"
        preserveAspectRatio="none"
        style="width: 125px; height: 125px"
        autoplay/>
    </div>
    <div class="r-image-headline headline">צריך לעצור...</div>
    <div class="r-text-regular content">
      <div>
        אי אפשר להמשיך בהצטרפות דיגטלית אם
        יש לך אזרחות אמריקאית או תושבות
        אמריקאית לצורכי מס.
      </div>
      <div>
        אפשר ליצור קשר עם שירות הלקוחות של
        ׳מיטב׳ ב-3366*.
      </div>
    </div>
    <dialog-button label="הבנתי" @click="hide" />
  </default-dialog>
</template>

<script>
import GlobalDialog from '@/components/base/GlobalDialog';
import DefaultDialog from '@/components/styled/DefaultDialog';
import DialogButton from '@/components/styled/DialogButton';

export default {
  name: 'TaxStateNotSupported',
  components: { DialogButton, DefaultDialog },
  mixins: [GlobalDialog],
  methods: {
    onCancelClick() {
      this.hide();
    },
  },
};
</script>

<style scoped lang="scss">

.image-headline {
  margin-bottom: 36px;
}

.headline {
  margin-bottom: 36px;
}

.content {
  div {
    margin-bottom: 36px;
  }
}
</style>
